import React from 'react';
import FieldSelector from './FieldSelector';

const ReportTemplateFieldSelector = ({ availableFields, initialHeaders, initialValues }) => {
  // Parse the initial headers and values
  let initialSelectedFields = [];

  if (initialValues && initialValues.length > 0) {
    // If we have initial values, use those directly
    initialSelectedFields = initialValues;
  } else if (initialHeaders && initialHeaders.length > 0) {
    // Otherwise, try to parse the headers string
    initialSelectedFields = initialHeaders.split(',').filter(h => h.trim() !== '');
  }

  return (
    <FieldSelector
      availableFields={availableFields}
      initialSelectedFields={initialSelectedFields}
    />
  );
};

export default ReportTemplateFieldSelector;